import { render } from "./FractionQuests.vue?vue&type=template&id=41ead5c2"
import script from "./FractionQuests.vue?vue&type=script&lang=js"
export * from "./FractionQuests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__